import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useToast } from './useToast';

const TOAST_ID = 'removed-saved-set-filter';

const getToastMessage = (removedFilters: string): string => {
  if (removedFilters.includes('role_taxonomy')) {
    return 'Your role filters were removed due to taxonomy changes. Please re-select them.';
  }

  const filterNames = removedFilters.split(',').join(' and ');
  return `Your ${filterNames} filters have been removed from your saved filter set. Please re-add them.`;
};

export const useRemovedSavedSetFilter = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const removedFilters = params.get('removedFilters');

    if (!removedFilters || toast.isActive(TOAST_ID)) {
      return;
    }

    toast({
      title: getToastMessage(removedFilters),
      status: 'warning',
      duration: 6000,
      isClosable: true,
      position: 'top-right',
      id: TOAST_ID,
    });

    // Clean up URL parameter
    params.delete('removedFilters');
    navigate(
      {
        pathname: location.pathname,
        search: params.toString(),
      },
      { replace: true }
    );
  }, [location.search, location.pathname, navigate, toast]);
};
